const WORKER_URL = (import.meta.env.VITE_WORKER_URL ?? "").replace(/\/$/, "");

async function http<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${WORKER_URL}${path}`, {
    credentials: "include",
    ...init,
    headers: { "Content-Type": "application/json", ...(init?.headers ?? {}) },
  });
  if (!res.ok) {
    let msg = `${init?.method ?? "GET"} ${path} → ${res.status}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body.error) msg = body.error;
    } catch {}
    throw new Error(msg);
  }
  return (await res.json()) as T;
}

export interface Project {
  name: string;
  full_name: string;
  html_url: string;
  private: boolean;
}

export interface Adr {
  name: string;
  path: string;
  html_url: string;
  sha: string;
}

export const api = {
  me: () => http<{ email: string; sub: string }>("/api/me"),
  projects: () => http<{ projects: Project[] }>("/api/projects"),
  adrs: (repo: string) => http<{ adrs: Adr[] }>(`/api/projects/${encodeURIComponent(repo)}/adrs`),
  chat: (messages: { role: "user" | "model"; text: string }[], repo?: string) =>
    http<{ text: string }>("/api/chat", {
      method: "POST",
      body: JSON.stringify({ messages, repo }),
    }),
  manage: (payload: unknown) =>
    http<{ ok: boolean; result?: unknown; error?: string }>("/api/manage_github", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};

export function geminiLiveUrl(): string {
  const base = WORKER_URL.replace(/^http/, "ws");
  return `${base}/ws/gemini-live`;
}
